var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#FD5917"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1411 11L19.6611 16.1027H36.4307V11H24.1411ZM34.9705 14.6439H22.8762L24.7953 12.4588H34.9705V14.6439Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.483 17.4407L17.0568 19.064L15.4756 20.8704L14.0216 22.5248L14.0061 22.5403H23.7194V17.4376H18.4861L18.483 17.4407ZM22.2622 21.0815H17.2211L18.1047 20.0758C18.1202 20.0603 18.1326 20.0417 18.1481 20.0262L19.1402 18.8964H22.2591V21.0815H22.2622Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.533 20.4388C16.533 19.9422 16.7127 19.4551 17.0568 19.064L24.138 11H26.9934V12.4588H24.7953L18.1482 20.0291C17.8971 20.3146 18.0056 20.625 18.0459 20.7119C18.0862 20.7988 18.2443 21.0875 18.6257 21.0875H20.7866V22.5463H18.6257C17.7917 22.5463 17.0631 22.0745 16.719 21.3141C16.5919 21.0316 16.5299 20.7368 16.5299 20.4419L16.533 20.4388Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6581 34.6762L24.138 39.7789H36.4277V34.6762H19.6581ZM34.9705 38.3201H24.7953L22.8762 36.135H34.9705V38.3201Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0186 28.2515L15.4726 29.9059L18.48 33.3356H23.7133V28.2329H14L14.0186 28.2515ZM19.1434 31.8799L17.2243 29.6948H22.2654V31.8799H19.1434Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5329 30.3373C16.5329 30.0455 16.5949 29.7476 16.722 29.4651C17.0662 28.7047 17.7947 28.2329 18.6287 28.2329H20.7897V29.6917H18.6287C18.2474 29.6917 18.0893 29.9772 18.049 30.0673C18.0087 30.1542 17.9002 30.4646 18.1513 30.7501L24.7984 38.3173H26.9965V39.7761H24.1411L17.06 31.7123C16.7127 31.3181 16.536 30.8308 16.536 30.3373H16.5329Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7163 19.9267H22.2622V32.609H23.7163V19.9267Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.359 21.2396H16.9049V29.4338H18.359V21.2396Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4725 20.8705V29.9089L14.0186 28.2515L14.0185 22.5249L15.4725 20.8705Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.738 14.815H22.2839V35.6666H23.738V14.815Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.026adcd48fb8f40e691bce128aa5e49c.svg";
export { ForwardRef as ReactComponent };